import React from 'react'
import _ from 'lodash'
import { OnlineAuctionSegmentBid } from '@adc/sdk/types'
import { useCounterOfferCountdown } from './utils'
import { InfoPill, Text } from '../../../elementals'
import { ColorNames } from '../../../../constants'
import * as utils from '../../../../utils'

interface CounterOfferCountdownProps {
  bid: OnlineAuctionSegmentBid
  className?: string
}

const CounterOfferCountdown = ({
  bid,
  className,
}: CounterOfferCountdownProps) => {
  const expirationDate = _.get(bid?.terms, 'expiration_date')

  const secondsRemaining = useCounterOfferCountdown(bid)

  if (!expirationDate || secondsRemaining <= 0) return null

  return (
    <div className={className}>
      <InfoPill
        size='small'
        backgroundColor={ColorNames.CautionLight}
        foregroundColor={ColorNames.Caution}
        includeBorder
        iconName='clock'
        extraPadding='small'
        label={
          <>
            <Text.Body as='div' size='small' color={ColorNames.Caution}>
              This Counteroffer expires in{' '}
              <strong>
                {utils.countdown.formatCountdownTimeWithoutText(
                  secondsRemaining
                )}
              </strong>
            </Text.Body>
          </>
        }
      />
    </div>
  )
}

export default CounterOfferCountdown
